var isPc = window.innerWidth >= 981;
var imagesList = document.querySelectorAll("#MainContent img");


for (var tempIndex = 0; tempIndex < imagesList.length; tempIndex++) {
  var tempImage = imagesList[tempIndex];
  if (!tempImage.getAttribute("src")) {
    tempImage.setAttribute(
      "src",
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    );
  }
}

function pcPageInit() {
  //注册图片懒加载
  new LazyLoad({
    elements_selector: "#MainContent img",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    threshold: "1000",
    callback_enter: function (element) { },
  });
  
  new LazyLoad({
    elements_selector: "#MainContent video",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    data_poster: "cbcn-poster",
    threshold: "1000",
    callback_enter: function (element) { },
  });

  //* 视频轮播 001 begin
new Swiper(".jp-banner-swiper", {
    spaceBetween: 30,
    centeredSlides: true,
    
    pagination: {
        el: ".banner-slider .swiper-pagination",
        clickable: true, // 改为 true，让用户可以点击切换
    },
    
    navigation: {
        nextEl: ".banner-slider .swiper-button-next",
        prevEl: ".banner-slider .swiper-button-prev",
    },
    
    // 视频处理事件
    on: {
        // 切换幻灯片时
        slideChange: function () {
            var self = this;
            
            // 暂停所有视频
            var allVideos = document.querySelectorAll('.jp-banner-swiper video');
            allVideos.forEach(function(video) {
                video.pause();
            });
            
            // 播放当前幻灯片的视频
            setTimeout(function() {
                var activeSlide = self.slides[self.activeIndex];
                if (activeSlide) {
                    var activeVideo = activeSlide.querySelector('video');
                    if (activeVideo) {
                        activeVideo.currentTime = 0;
                        activeVideo.play().catch(function() {
                            // 静默处理播放失败（autoplay 会兜底）
                        });
                    }
                }
            }, 150);
        },
        
        // 初始化时播放第一个视频
        init: function() {
            var self = this;
            setTimeout(function() {
                var firstSlide = self.slides[self.activeIndex];
                if (firstSlide) {
                    var firstVideo = firstSlide.querySelector('video');
                    if (firstVideo) {
                        firstVideo.play().catch(function() {
                            // 静默处理
                        });
                    }
                }
            }, 150);
        }
    }
});


  // 视频轮播 002 end


  // 产品轮播 begin

     new Swiper('.product-swiper', {
            // Optional parameters
            direction: 'horizontal',

            effect: 'slide',
            speed: 800,
            
            // Responsive breakpoints
            breakpoints: {
  
                // When window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 16
                }
            },

            // Pagination
            pagination: {
                el: '.product-pagination',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.product-next',
                prevEl: '.product-prev',
            },

      });


  // 产品轮播 end


  //  family begin

        new Swiper('.family', {
            direction: 'horizontal',
            speed: 800,
            
            // 响应式断点
            breakpoints: {

                1024: {
                    spaceBetween: 16,
                    slidesPerView: 3.5,
                },
            },

            // Pagination
            pagination: {
                el: '.ok',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.family-next',
                prevEl: '.family-prev',
            },
        });
  //  family end






//lucida begin

new Swiper('.lucidaswiper', {
        // Optional parameters
        direction: 'horizontal',
        effect: 'fade',
        /*
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },*/

        // Pagination
        pagination: {
            el: '.lucida-pagination',
            clickable: true,
            dynamicBullets: false,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.lucida-next',
            prevEl: '.lucida-prev',
        },

        // Responsive breakpoints
        breakpoints: {

            1024: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
        }
    });



//lucida end


//fair begin

        new Swiper('.fairpc', {
            direction: 'horizontal',
            speed: 800,
            
            // 响应式断点
            breakpoints: {
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 3.5,
                },
            },

            // Pagination
            pagination: {
                el: '.fairokpc',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.fairpc-next',
                prevEl: '.fairpc-prev',
            },
        });




//fair end


//第十个 begin


new Swiper('.promisepc', {
            direction: 'horizontal',
            speed: 800,
            
            // 响应式断点
            breakpoints: {
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 3,
                },
            },

            // Pagination
            pagination: {
                el: '.promisepc-pagination',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.promisepc-next',
                prevEl: '.promisepc-prev',
            },
});



// 第十个 end



}

if (isPc) {
  window.onload = function () {
    // 这段代码的作用是：检测用户是否使用的是 Internet Explorer 浏览器（特别是 IE11 及更早版本），如果是，就不加载主内容，只显示一个提示或占位元素。否则就移除 loading 效果，正常加载内容。
    var UA = window.navigator.userAgent;
    if (
      (UA.indexOf("Trident") > -1 && UA.indexOf("rv:11.0") > -1) ||
      UA.indexOf("MSIE") > -1
    ) {
         console.log('IE 11以前版本');
    } else {
         console.log('IE 11以后版本');
    }

    pcPageInit();
  };
}